import { render, staticRenderFns } from "./znyxbg.vue?vue&type=template&id=58fda034&scoped=true"
import script from "./znyxbg.vue?vue&type=script&lang=js"
export * from "./znyxbg.vue?vue&type=script&lang=js"
import style0 from "./znyxbg.vue?vue&type=style&index=0&id=58fda034&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fda034",
  null
  
)

export default component.exports